// Maps a raw stake code (e.g. "two_bot") to its numadd.betTypes.* i18n
// key — used as a fallback label when the backend's own reward-type name
// (fetched from /getLottoRewardTypes, keyed by code) doesn't have an
// entry for a given code, instead of falling back straight to the raw
// code string.
export const BET_TYPE_I18N_KEY = {
  first: "first",
  four_top: "fourTop",
  four_tod: "fourTod",
  three_top: "threeTop",
  three_front: "threeFront",
  three_bot: "threeBot",
  three_tod: "threeTod",
  two_top: "twoTop",
  two_bot: "twoBot",
  run_top: "runTop",
  run_bot: "runBot",
};

export function getBetTypeLabel(code, apiName, t) {
  if (apiName) return apiName;
  const key = BET_TYPE_I18N_KEY[code];
  return key ? t(`numadd.betTypes.${key}`) : code;
}
